/*
 * This is a wrapper for the TaskTypeCC component that enables use in a components for
 * add/edit of a card on file that is independent of the task list.
 */
import React, { Component } from 'react';
import { Button, Grid } from '@mui/material';
import TaskTypeCC from '../tasks/TaskTypeCC';
import PropTypes from 'prop-types';
import AppBindStyles from '../../AppBindStyles';

class TaskTypeCCWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      completeDisabled: true,
    };
  }

  isCompleteDisabled = () => {
    return this.state.completeDisabled;
  }

  setCompleteDisabled = (cd) => {
    this.setState({completeDisabled: cd});
  }

  saveCC = () => {
    Promise.resolve().then(() => {
      // console.log('Call taskTypeCC.handleDoneFromParent');
      return this.child.handleDoneFromParent();
    }).then(() => {
      this.props.closeAction("saved");
    }).catch((error) => {
      //console.log('Error=' + JSON.stringify(error));
    });
  }

  render() {
    let theTask = this.props.task;
 
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TaskTypeCC
            omitTitle={true}
            country="US"
            auth={this.props.auth}
            task={theTask}
            done={false}
            isCompleteDisabled={this.isCompleteDisabled}
            setCompleteDisabled={this.setCompleteDisabled}
            ref={(child) => this.child = child}
          />
        </Grid>
        <Grid item xs={12}>
          <Button onClick={() => this.saveCC()} color="primary" style={AppBindStyles.bottomButton} variant="contained" disabled={this.state.completeDisabled}>
            Save
          </Button>
          <Button onClick={() => this.props.closeAction()} style={AppBindStyles.bottomButton} color="primary" variant="outlined">
            Cancel
          </Button>
        </Grid>
      </Grid>
    )
  }
}

TaskTypeCCWrapper.propTypes = {
  auth: PropTypes.object.isRequired,
};


export default TaskTypeCCWrapper;

